import {HelperOptions} from 'handlebars';

/**
 * Helper for formatting an ISO 8601 or Unix timstamp date. Supported date-parts for formatting are:
 *
 * - d: two-digit day of the month.
 * - m: two-digit month of the year.
 * - Y: four-digit year.
 * - H: two-digit 24-hour style hour of the day
 * - i: two-digit minute of the hour
 * - s: two-digit second of the minute
 *
 * @param {string|number} value Date to format
 * @param {HelperOptions} options Helper options
 * @returns {string}
 * @author Philipp Seiler <sep@earlybird.at>
 */
const formatDate = (value: string | number, options: HelperOptions): string => {
  let format = 'd.m.Y';
  if (options.hash.hasOwnProperty('format')) {
    format = options.hash.format;
  }
  const integerValue = parseInt(value.toString());
  if (!isNaN(integerValue)) {
    value = (integerValue * 1000);
  }
  const date = new Date(value);
  if (format.indexOf('d') !== -1) {
    format = format.replace('d', date.getDate().toString().padStart(2, '0'));
  }
  if (format.indexOf('m') !== -1) {
    format = format.replace('m', (date.getMonth() + 1).toString().padStart(2, '0'));
  }
  if (format.indexOf('Y') !== -1) {
    format = format.replace('Y', date.getFullYear().toString());
  }
  if (format.indexOf('H') !== -1) {
    format = format.replace('H', date.getHours().toString().padStart(2, '0'));
  }
  if (format.indexOf('i') !== -1) {
    format = format.replace('i', date.getMinutes().toString().padStart(2, '0'));
  }
  if (format.indexOf('s') !== -1) {
    format = format.replace('s', date.getSeconds().toString().padStart(2, '0'));
  }
  return format;
};
export default formatDate;
